import React from 'react';
import { DeleteBudgetButton } from './DeleteBudgetButton';
import { ExportCSVButton } from './ExportCSVButton';
import { Budget } from '../types/budget';
import { EntitiesManagementButton } from './EntitiesManagementButton';
import { BudgetSettingsButton } from './BudgetSettingsButton';

interface BudgetActionsProps {
  budget: Budget & { id: number };
  showText?: boolean;
  className?: string;
  spacing?: string;
  onDeleteSuccess?: () => void;
}

export const BudgetActions: React.FC<BudgetActionsProps> = ({
  budget,
  showText = false,
  className = '',
  spacing = 'space-x-2',
  onDeleteSuccess,
}) => {
  return (
    <div className={`flex flex-wrap items-center gap-2 sm:flex-nowrap sm:${spacing}`}>
      <EntitiesManagementButton
        budget={budget}
        showText={showText}
        className={`flex-1 sm:flex-none ${className}`}
      />
      <DeleteBudgetButton
        budgetId={budget.id}
        showText={showText}
        className={`flex-1 sm:flex-none ${className}`}
        onSuccess={onDeleteSuccess}
      />
      <ExportCSVButton
        budget={budget}
        showText={showText}
        className={`flex-1 sm:flex-none ${className}`}
      />
      <BudgetSettingsButton
        budget={budget}
        showText={showText}
        className={`flex-1 sm:flex-none ${className}`}
      />
    </div>
  );
};
